import React, { Component } from 'react'
import { Affix, Button, Popover, Dropdown, Menu } from 'antd';
import {
  CustomerServiceOutlined, UpOutlined, QrcodeOutlined
} from '@ant-design/icons';
import img_mian from '../assets/images/imgs/service.jpg'
interface TransportState {
  isModalOpen: boolean;
}
const content = (
  <div style={{}}>
    <img style={{ width: '200px', height: '200px', }} src={img_mian} alt="" />
    <div style={{ width: '100%', textAlign: 'center', }} >更多信息请扫码咨询</div>
  </div>
);
const twoContent = (
  <div>
    <div>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <CustomerServiceOutlined />
        <div style={{ paddingLeft: '20px', fontWeight: '700' }}>在线客服</div>
      </div>
      <div style={{ paddingLeft: '40px', color: '#999' }}>
        工作时间:9:30-18:00
      </div>
      <div style={{ paddingLeft: '40px', color: '#999' }}>
        热线电话:400-6061-938
      </div>
    </div>
  </div>
)
const menu = (
  <Menu>
    <Menu.Item key="1">
      <Popover placement="left" content={content} >
        <Button
          shape="circle"
          icon={<QrcodeOutlined />}
        >
        </Button>
      </Popover>
    </Menu.Item>
    <Menu.Item key="2">
      <Popover placement="left" content={twoContent}>
        <Button
          shape="circle"
          icon={<CustomerServiceOutlined />}
        >
        </Button>
      </Popover>
    </Menu.Item>

  </Menu>
);
export default class Transport extends Component<{}, TransportState> {
  render() {
    return (
      <div >
        <Affix style={{ position: 'fixed', bottom: 200, right: 30, zIndex: 9999 }}>
          <Dropdown overlay={menu} placement="topCenter" >
            <Button
              size='large'
              shape="circle"
              icon={<UpOutlined />}
            >
            </Button>
          </Dropdown>
        </Affix>
      </div>
    );
  }
}
